import React from "react";
import { Route } from "react-router-dom";
// import Login from "pages/memberAuth/Login";
import { Redirect } from "react-router-dom";
import { getAuthenticated } from "utils/functions";

export const PrivateRoute = ({ children, ...rest }) => {
  const isAuthenticated = getAuthenticated();

  return (
    <Route
      {...rest}
      render={() => (isAuthenticated ? children : <Redirect to="/login" />)}
    />
  );
};
